module.exports = __webpack_public_path__ + "img/step1.0078ca7e.png";